// src/pages/dashboard/admin/turmasAdmin.js
import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    Form,
    Table,
    Alert,
    Card,
    Row,
    Col,
    InputGroup,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlus,
    faEdit,
    faTrash,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
import "../../../scss/belts.css";

export default function TurmasAdmin() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");
    const authHeaders = () => ({ Authorization: `Bearer ${token}` });

    const [turmas, setTurmas] = useState([]);
    const [praticantes, setPraticantes] = useState([]);
    const [turmasPraticantes, setTurmasPraticantes] = useState([]);


    const GRADUACOES = [
        { value: 0, nome: "9º Kyu", cor: "Branco", className: "belt-white" },
        { value: 1, nome: "8º Kyu", cor: "Amarelo", className: "belt-yellow" },
        { value: 2, nome: "7º Kyu", cor: "Laranja", className: "belt-orange" },
        { value: 3, nome: "6º Kyu", cor: "Verde", className: "belt-green" },
        { value: 4, nome: "5º Kyu", cor: "Azul", className: "belt-blue" },
        { value: 5, nome: "4º Kyu", cor: "Vermelho", className: "belt-red" },
        { value: 6, nome: "3º Kyu", cor: "Castanho", className: "belt-brown" },
        { value: 7, nome: "2º Kyu", cor: "Castanho", className: "belt-brown" },
        { value: 8, nome: "1º Kyu", cor: "Castanho", className: "belt-brown" },
        ...Array.from({ length: 10 }, (_, i) => ({
            value: 9 + i,
            nome: `${i + 1}º Dan`,
            cor: "Preto",
            className: "belt-black"
        }))
    ];

    const getGraduacaoInfo = (value) =>
        GRADUACOES.find(g => g.value === value);

    const calcularIdade = (dataNascimento) => {
        if (!dataNascimento) return null;
        const nascimento = new Date(dataNascimento);
        if (isNaN(nascimento)) return null;

        const hoje = new Date();
        let idade = hoje.getFullYear() - nascimento.getFullYear();
        const m = hoje.getMonth() - nascimento.getMonth();
        if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
            idade--;
        }
        return idade;
    };

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    // Modal Turma
    const [showTurmaModal, setShowTurmaModal] = useState(false);
    const [editingTurma, setEditingTurma] = useState(null);
    const [turmaForm, setTurmaForm] = useState({ turma: "", idadeMin: 0 });

    // Modal Adicionar/Remover praticantes
    const [showPraticantesModal, setShowPraticantesModal] = useState(false);
    const [selectedTurma, setSelectedTurma] = useState(null);
    const [turmaPraticantesList, setTurmaPraticantesList] = useState([]);
    const [searchPraticante, setSearchPraticante] = useState("");

    const [orderBy, setOrderBy] = useState("nome"); // nome | idade | graduacao
    const [orderDir, setOrderDir] = useState("asc"); // asc | desc


    useEffect(() => {
        loadAll();
    }, []);

    const loadAll = async () => {
        setLoading(true);
        try {
            const [resT, resP, resTP] = await Promise.all([
                fetch(`${API_BASE_URL}/Turmas`, { headers: authHeaders() }),
                fetch(`${API_BASE_URL}/Praticantes`, { headers: authHeaders() }),
                fetch(`${API_BASE_URL}/TurmasPraticantes`, { headers: authHeaders() }),
            ]);

            setTurmas(resT.ok ? await resT.json() : []);
            setPraticantes(resP.ok ? await resP.json() : []);
            setTurmasPraticantes(resTP.ok ? await resTP.json() : []);
        } catch (err) {
            console.error(err);
            setError("Erro ao carregar dados.");
        } finally {
            setLoading(false);
        }
    };

    // -----------------------
    // Criar / editar / apagar turma
    // -----------------------
    const openCreateTurma = () => {
        setTurmaForm({ turma: "", idadeMin: 0 });
        setEditingTurma(null);
        setShowTurmaModal(true);
    };

    const openEditTurma = (t) => {
        setEditingTurma(t);
        setTurmaForm({ turma: t.turma || "", idadeMin: t.idadeMin || 0 });
        setShowTurmaModal(true);
    };

    const saveTurma = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!turmaForm.turma) {
            setError("O nome da turma é obrigatório.");
            return;
        }

        try {
            const res = await fetch(
                `${API_BASE_URL}/Turmas${editingTurma ? `/${editingTurma.id}` : ""}`,
                {
                    method: editingTurma ? "PUT" : "POST",
                    headers: { "Content-Type": "application/json", ...authHeaders() },
                    body: JSON.stringify(turmaForm),
                }
            );

            if (!res.ok) throw new Error(await res.text());
            setSuccess(editingTurma ? "Turma atualizada." : "Turma criada.");
            setShowTurmaModal(false);
            await loadAll();
        } catch (err) {
            console.error(err);
            setError("Erro ao guardar turma.");
        }
    };

    const deleteTurma = async (t) => {
        if (!window.confirm(
            `Deseja eliminar a turma "${t.turma}"? Todas as aulas e associações de praticantes desta turma serão também eliminadas.`
        )) return;

        try {
            // 1. apagar todas as associações de TurmasPraticante
            const turmaPraticantes = turmasPraticantes.filter(tp => tp.turmaId === t.id);
            for (const tp of turmaPraticantes) {
                await fetch(`${API_BASE_URL}/turmaspraticantes/${tp.id}`, {
                    method: "DELETE",
                    headers: authHeaders(),
                });
            }

            // 2. apagar todas as associações de TurmasAula
            const turmaAulasRes = await fetch(`${API_BASE_URL}/turmasaulas`, { headers: authHeaders() });
            const turmaAulas = turmaAulasRes.ok ? await turmaAulasRes.json() : [];
            const aulasDaTurma = turmaAulas.filter(ta => ta.turmaId === t.id);

            for (const ta of aulasDaTurma) {
                await fetch(`${API_BASE_URL}/turmasaulas/${ta.id}`, { // assumindo que cada TA tem um Id
                    method: "DELETE",
                    headers: authHeaders(),
                });
            }

            // 3. apagar a turma
            await fetch(`${API_BASE_URL}/turmas/${t.id}`, {
                method: "DELETE",
                headers: authHeaders(),
            });

            setSuccess("Turma eliminada.");
            await loadAll();
        } catch (err) {
            console.error(err);
            setError("Erro ao eliminar turma.");
        }
    };

    // -----------------------
    // Adicionar/Remover praticantes à turma
    // -----------------------
    const openPraticantesModal = (t) => {
        setSelectedTurma(t);
        const associated = turmasPraticantes.filter((tp) => tp.turmaId === t.id);
        const list = praticantes.map((p) => ({
            praticante: p,
            checked: !!associated.find((a) => a.praticanteId === p.id),
        }));
        setTurmaPraticantesList(list);
        setShowPraticantesModal(true);
        setSearchPraticante("");
    };

    const togglePraticanteCheck = (prId) => {
        setTurmaPraticantesList((old) =>
            old.map((x) =>
                x.praticante.id === prId ? { ...x, checked: !x.checked } : x
            )
        );
    };

    const savePraticantes = async () => {
        if (!selectedTurma) return;
        setError("");
        setSuccess("");

        const toCreate = [];
        const toDelete = [];

        for (const item of turmaPraticantesList) {
            const assoc = turmasPraticantes.find(tp => tp.turmaId === selectedTurma.id && tp.praticanteId === item.praticante.id);

            if (item.checked && !assoc) {
                toCreate.push({ turmaId: selectedTurma.id, praticanteId: item.praticante.id });
            }

            if (!item.checked && assoc) {
                toDelete.push(assoc.id); // pega o Id único da associação
            }
        }

        try {
            // Criar associações
            for (const c of toCreate) {
                await fetch(`${API_BASE_URL}/TurmasPraticantes`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", ...authHeaders() },
                    body: JSON.stringify(c),
                });
            }

            // Remover associações
            for (const id of toDelete) {
                await fetch(`${API_BASE_URL}/TurmasPraticantes/${id}`, {
                    method: "DELETE",
                    headers: authHeaders(),
                });
            }

            setSuccess("Turma atualizada com praticantes.");
            setShowPraticantesModal(false);
            await loadAll();
        } catch (err) {
            console.error(err);
            setError("Erro ao atualizar praticantes.");
        }
    };

    const countPraticantes = (turmaId) => {
        return turmasPraticantes.filter((tp) => tp.turmaId === turmaId).length;
    };

    const praticantesProcessados = turmaPraticantesList
        .filter(x =>
            x.praticante.nome
                .toLowerCase()
                .includes(searchPraticante.toLowerCase())
        )
        .sort((a, b) => {
            const pA = a.praticante;
            const pB = b.praticante;

            if (orderBy === "idade") {
                const idadeA = calcularIdade(pA.dataNascimento) ?? -1;
                const idadeB = calcularIdade(pB.dataNascimento) ?? -1;
                return orderDir === "asc" ? idadeA - idadeB : idadeB - idadeA;
            }

            if (orderBy === "graduacao") {
                const gA = pA.graduacao ?? 0;
                const gB = pB.graduacao ?? 0;
                return orderDir === "asc" ? gA - gB : gB - gA;
            }

            return pA.nome.localeCompare(pB.nome);
        });

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap gap-3 align-items-start py-4">
                <div>
                    <h1 className="h4 mb-1">Gestão de Turmas</h1>
                    <p className="mb-0 text-muted">Gerencie as turmas e adicione/remova praticantes.</p>
                </div>
                <Button variant="primary" onClick={openCreateTurma}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Nova Turma
                </Button>
            </div>

            {error && <Alert variant="danger" onClose={() => setError("")} dismissible>{error}</Alert>}
            {success && <Alert variant="success" onClose={() => setSuccess("")} dismissible>{success}</Alert>}

            {/* Tabela — desktop */}
            <div className="d-none d-md-block">
                <Card className="shadow-sm mb-4">
                    <Card.Body className="p-0">
                        <Table responsive hover className="mb-0">
                            <thead className="thead-light">
                            <tr>
                                <th>Turma</th>
                                <th>Idade Mín.</th>
                                <th>Nº Praticantes</th>
                                <th>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {turmas.map((t) => (
                                <tr key={t.id}>
                                    <td className="fw-bold">{t.turma}</td>
                                    <td>{t.idadeMin} anos</td>
                                    <td>
                                        <span className="badge bg-secondary">{countPraticantes(t.id)}</span>
                                    </td>
                                    <td>
                                        <div className="d-flex flex-wrap gap-1">
                                            <Button size="sm" variant="outline-success" onClick={() => openPraticantesModal(t)}>
                                                <FontAwesomeIcon icon={faUserPlus} className="me-1" /> Praticantes
                                            </Button>
                                            <Button size="sm" variant="outline-secondary" onClick={() => openEditTurma(t)}>
                                                <FontAwesomeIcon icon={faEdit} />
                                            </Button>
                                            <Button size="sm" variant="outline-danger" onClick={() => deleteTurma(t)}>
                                                <FontAwesomeIcon icon={faTrash} />
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>

            {/* Cards — mobile */}
            <div className="d-md-none mb-4">
                {turmas.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "48px 20px", background: "white", borderRadius: 16 }}>
                        <p className="text-muted mb-0 fw-bold">Sem turmas registadas.</p>
                    </div>
                ) : turmas.map((t) => (
                    <div key={t.id} style={{ background: "white", borderRadius: 14, padding: 16, marginBottom: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.07)", border: "1px solid #f0f0f5" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                            <div style={{ fontWeight: 700, fontSize: 16, color: "#1e1d45" }}>{t.turma}</div>
                            <span className="badge bg-secondary">{countPraticantes(t.id)} praticantes</span>
                        </div>
                        <div style={{ fontSize: 13, color: "#6c757d", marginBottom: 12 }}>
                            Idade mínima: {t.idadeMin} anos
                        </div>
                        <div style={{ display: "flex", gap: 6, borderTop: "1px solid #f0f0f5", paddingTop: 10 }}>
                            <Button size="sm" variant="outline-success" className="flex-grow-1" onClick={() => openPraticantesModal(t)}>
                                <FontAwesomeIcon icon={faUserPlus} className="me-1" /> Praticantes
                            </Button>
                            <Button size="sm" variant="outline-secondary" onClick={() => openEditTurma(t)}>
                                <FontAwesomeIcon icon={faEdit} />
                            </Button>
                            <Button size="sm" variant="outline-danger" onClick={() => deleteTurma(t)}>
                                <FontAwesomeIcon icon={faTrash} />
                            </Button>
                        </div>
                    </div>
                ))}
            </div>

            {/* Modal Criar/Editar Turma */}
            <Modal
                show={showTurmaModal}
                centered
                onHide={() => setShowTurmaModal(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {editingTurma ? "Editar Turma" : "Nova Turma"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={saveTurma}>
                        <Form.Group className="mb-3">
                            <Form.Label>Nome da Turma</Form.Label>
                            <Form.Control
                                type="text"
                                value={turmaForm.turma}
                                onChange={(e) =>
                                    setTurmaForm({ ...turmaForm, turma: e.target.value })
                                }
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Idade Mínima</Form.Label>
                            <Form.Control
                                type="number"
                                value={turmaForm.idadeMin}
                                onChange={(e) =>
                                    setTurmaForm({
                                        ...turmaForm,
                                        idadeMin: parseInt(e.target.value),
                                    })
                                }
                                required
                            />
                        </Form.Group>
                        <div className="d-flex justify-content-end">
                            <Button
                                variant="secondary"
                                className="me-2"
                                onClick={() => setShowTurmaModal(false)}
                            >
                                Cancelar
                            </Button>
                            <Button variant="primary" type="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal Praticantes da Turma */}
            <Modal size="lg" show={showPraticantesModal} centered onHide={() => setShowPraticantesModal(false)} scrollable>
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>Praticantes da Turma</Modal.Title>
                        <div style={{ fontSize: 12, color: "#6c757d" }}>{selectedTurma?.turma}</div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 8, marginBottom: 14 }}>
                        {[
                            { label: "Na turma", value: turmaPraticantesList.filter(x => x.checked).length, color: "#198754" },
                            { label: "Total disponível", value: turmaPraticantesList.length, color: "#1e1d45" },
                        ].map(s => (
                            <div key={s.label} style={{ background: "#f8f9fa", borderRadius: 10, padding: "10px 8px", textAlign: "center", borderTop: `3px solid ${s.color}` }}>
                                <div style={{ fontSize: 20, fontWeight: 900, color: s.color }}>{s.value}</div>
                                <div style={{ fontSize: 10, color: "#6c757d", fontWeight: 600 }}>{s.label}</div>
                            </div>
                        ))}
                    </div>

                    <Row className="mb-3 g-2">
                        <Col xs={12} sm={6}>
                            <Form.Control placeholder="Pesquisar praticante..." value={searchPraticante} onChange={(e) => setSearchPraticante(e.target.value)} />
                        </Col>
                        <Col xs={6} sm={3}>
                            <Form.Select value={orderBy} onChange={e => setOrderBy(e.target.value)}>
                                <option value="idade">Por Idade</option>
                                <option value="graduacao">Por Graduação</option>
                            </Form.Select>
                        </Col>
                        <Col xs={6} sm={3}>
                            <Form.Select value={orderDir} onChange={e => setOrderDir(e.target.value)}>
                                <option value="asc">↑ Asc</option>
                                <option value="desc">↓ Desc</option>
                            </Form.Select>
                        </Col>
                    </Row>

                    {praticantesProcessados.map((item) => {
                        const p = item.praticante;
                        const g = getGraduacaoInfo(p.graduacao);
                        return (
                            <label key={p.id} style={{ display: "flex", alignItems: "center", padding: "12px 14px", background: "white", borderRadius: 12, marginBottom: 6, cursor: "pointer", border: item.checked ? "2px solid #1e1d45" : "1px solid #e9ecef", minHeight: 64 }}>
                                <div style={{ width: 28, height: 28, borderRadius: 6, border: `2px solid ${item.checked ? "#1e1d45" : "#dee2e6"}`, background: item.checked ? "#1e1d45" : "white", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 12, flexShrink: 0 }}>
                                    {item.checked && <span style={{ color: "white", fontSize: 14 }}>✓</span>}
                                </div>
                                <input type="checkbox" checked={!!item.checked} onChange={() => togglePraticanteCheck(p.id)} style={{ display: "none" }} />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontWeight: 600, fontSize: 14 }}>{p.nome}</div>
                                    <div style={{ display: "flex", gap: 8, marginTop: 2, flexWrap: "wrap" }}>
                                        {g && <span className={`belt-badge ${g.className}`} style={{ fontSize: 10 }}>{g.nome}</span>}
                                        {calcularIdade(p.dataNascimento) != null && <span style={{ fontSize: 12, color: "#6c757d" }}>{calcularIdade(p.dataNascimento)} anos</span>}
                                    </div>
                                </div>
                            </label>
                        );
                    })}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" className="flex-grow-1 flex-sm-grow-0" onClick={() => setShowPraticantesModal(false)}>Cancelar</Button>
                    <Button variant="primary" className="flex-grow-1 flex-sm-grow-0" onClick={savePraticantes}>Guardar</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
